import { Button } from "../ui/Button";

export type ContextualPillProps = {
  isLastQuestion: boolean;
  prevIdx: number | null;
  nextIdx: number | null;
  showRetry: boolean;
  onRetry: () => void;
  onFinalize: () => void;
  onJump: (idx: number) => void;
};

/**
 * Persistent exam action bar — three slots, always in the same place.
 *
 *   [ ← Vorige vraag ]   [ ↻ Opnieuw opnemen ]   [ Volgende vraag → ]
 */
export function ContextualPill({
  isLastQuestion,
  prevIdx,
  nextIdx,
  showRetry,
  onRetry,
  onFinalize,
  onJump,
}: ContextualPillProps) {
  return (
    <div className="sticky bottom-0 z-10 -mx-4 mt-2 bg-[var(--bg)] px-4 sm:-mx-6 sm:px-6 lg:static lg:mx-0 lg:bg-transparent lg:px-0">
      <div
        aria-hidden="true"
        className="lg:hidden -mt-2 h-2 bg-gradient-to-t from-[var(--bg)] to-transparent"
      />
      <div className="flex min-h-11 items-center gap-2 py-3 lg:py-0">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => prevIdx !== null && onJump(prevIdx)}
          disabled={prevIdx === null}
          aria-label="Ga naar vorige vraag"
          className="whitespace-nowrap"
        >
          ← Vorige
        </Button>
        {showRetry ? (
          <Button
            variant="secondary"
            size="sm"
            onClick={onRetry}
            aria-label="Probeer dezelfde vraag opnieuw"
            className="whitespace-nowrap"
          >
            ↻ Opnieuw
          </Button>
        ) : null}
        {isLastQuestion ? (
          <Button
            variant="warm"
            size="md"
            onClick={onFinalize}
            className="ml-auto whitespace-nowrap"
            aria-label="Ga naar uw resultaat"
          >
            Bekijk uw resultaat →
          </Button>
        ) : (
          <Button
            variant="warm"
            size="md"
            className="ml-auto whitespace-nowrap"
            onClick={() => nextIdx !== null && onJump(nextIdx)}
            disabled={nextIdx === null}
            aria-label="Ga naar volgende vraag"
          >
            Volgende vraag →
          </Button>
        )}
      </div>
    </div>
  );
}
